export default __webpack_public_path__ + "static/media/li-wedding-288-4.a1b844a8.jpg";